import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DropdownMenuSurfaceWidthConstantType,
    DropdownMenuSurfaceDynamicStyleType,
    DropdownMenuSurfaceWidthType
} from "./type";

export const DROPDOWN_MENU_MIN_WIDTH_ROWS = 8;

export const DROPDOWN_MENU_MAX_WIDTH_ROWS = 12;

export const getDropdownMenuSurfaceWidth = ({
    controlHeights,
    widthBehaviour,
    triggerWidth
}: DropdownMenuSurfaceWidthConstantType): DropdownMenuSurfaceWidthType => {
    if(widthBehaviour === "trigger" && triggerWidth > 0) {
        return {
            width: triggerWidth
        };
    }

    const minWidth = Math.max(triggerWidth, controlHeights.small * DROPDOWN_MENU_MIN_WIDTH_ROWS);

    return {
        maxWidth: Math.max(controlHeights.small * DROPDOWN_MENU_MAX_WIDTH_ROWS, minWidth),
        minWidth
    };
};

const stylesheet = StyleSheet.create({
    scroll: {
        flexShrink: 1
    }
});

export const useStyles = ({
    isSubMenu,
    borders,
    padding,
    spaces
}: DropdownMenuSurfaceDynamicStyleType) => {
    const styles = {
        scroll: {
            marginHorizontal: -spaces[padding],
            marginVertical: -spaces[padding]
        } as ViewStyle,
        content: {
            padding: spaces[padding]
        } as ViewStyle,
        surface: {} as ViewStyle
    };

    if(isSubMenu) {
        styles.surface.marginTop = -(spaces[padding] + borders.line);
    }

    return styles;
};
export default stylesheet;
